import { PRIMITIVE_COLOR_PALETTES } from '@/adapters/primitive/_data/config/fragments/colorPalettes';
import type { Config } from '@/adapters/primitive/_contract/config';

export function withPrimitiveColorPalette(
    config: Config,
    name: keyof typeof PRIMITIVE_COLOR_PALETTES,
): Config {
    if (!Object.hasOwn(PRIMITIVE_COLOR_PALETTES, name)) {
        throw new RangeError(`Unknown primitive color palette '${name}'.`);
    }
    const colors = PRIMITIVE_COLOR_PALETTES[name];
    const preview = config.natural.display.settlementPreview;

    return {
        ...config,
        base: {
            ...config.base,
            display: {
                ...config.base.display,
                emphasis: { ...config.base.display.emphasis, color: colors.base.emphasis.color },
                cell: { ...config.base.display.cell, countedColor: colors.base.cell.counted, uncountedColor: colors.base.cell.uncounted },
                placeholder: { ...config.base.display.placeholder, outlineColor: colors.base.placeholder.outline },
                label: {
                    ...config.base.display.label,
                    digitLabelColor: colors.base.label.text,
                    backgroundColor: colors.base.backgroundColor,
                },
            },
        },
        boolean: {
            ...config.boolean,
            display: {
                ...config.boolean.display,
                decisiveOutline: { ...config.boolean.display.decisiveOutline, color: colors.boolean.decisiveOutline.color },
                splitMarker: { ...config.boolean.display.splitMarker, color: colors.base.placeholder.outline },
            },
        },
        natural: {
            ...config.natural,
            display: {
                ...config.natural.display,
                cell: {
                    ...config.natural.display.cell,
                    overhangColor: colors.natural.cell.overhang,
                    deficitMarkerColor: colors.natural.cell.deficitMarker,
                    zeroSlotColor: colors.natural.cell.zero,
                    comparisonDecisiveCellColor: colors.natural.comparison.decisiveCell,
                },
                settlementPreview: { ...preview, wall: { ...preview.wall, color: colors.base.placeholder.outline } },
                comparison: {
                    ...config.natural.display.comparison,
                    rayColor: colors.natural.comparison.ray,
                    helperCircle: {
                        ...config.natural.display.comparison.helperCircle,
                        outlineColor: colors.natural.comparison.helperCircleOutline,
                    },
                },
                marker: {
                    ...config.natural.display.marker,
                    canonicalZero: { ...config.natural.display.marker.canonicalZero, color: colors.natural.canonicalZeroMarker.color },
                    axialTie: { ...config.natural.display.marker.axialTie, color: colors.natural.axialTie.color },
                    axisRod: { ...config.natural.display.marker.axisRod, color: colors.natural.axisRod.color },
                },
            },
        },
    };
}
